module.exports = __webpack_public_path__ + "749a0a2a2cfd8324cc0cc37825d76cbc.MP3";